module.exports = __webpack_public_path__ + "img/fog.550d3748.svg";